var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4611 11.1076H15.201V24.9103L26.4611 11.1076Z",
    fill: "#F37A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7391 2.0269L16.6539 8.20179H26.4611L21.7391 2.0269Z",
    fill: "#F37A20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4701 0.210754H9.02614L13.7481 7.1121L18.4701 0.210754Z",
    fill: "#F37A20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.479 8.20179L5.03062 2.0269L0.671875 8.20179H10.479Z",
    fill: "#F37A20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2952 11.1076H0.671875L12.2952 24.9103V11.1076Z",
    fill: "#F37A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond1);
export default __webpack_public_path__ + "static/media/diamond1.e5e494ec56187431ec42183876049c3b.svg";
export { ForwardRef as ReactComponent };